export default __webpack_public_path__ + "static/media/plantup-intelligence.1ffbe1fb.png";